(function () {
  function showFeedback(button, message) {
    var label = button.querySelector('[data-cart-share-label]');
    if (!label) return;
    var original = label.getAttribute('data-original-label') || label.textContent.trim();
    label.setAttribute('data-original-label', original);
    label.textContent = message;
    button.classList.add('cart-share--copied');
    setTimeout(function () {
      label.textContent = original;
      button.classList.remove('cart-share--copied');
    }, 2000);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-share-button]');
    if (!button) return;
    event.preventDefault();

    var url = button.getAttribute('data-share-url');
    if (!url) return;

    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        showFeedback(button, 'Link copied!');
      }).catch(function () {
        window.prompt('Copy this link to share your cart:', url);
      });
    } else {
      window.prompt('Copy this link to share your cart:', url);
    }
  });
})();
